import { controlledDocumentIsPreviewable } from "@/lib/documents";

export type RfqSkuDocumentAccessSummary = {
  documentsModule: boolean;
  documentsAccess?: string;
  sharedOnly: boolean;
};

export type RfqSkuDocumentAccessDocument = {
  can_preview?: boolean;
  can_download?: boolean;
  can_read?: boolean;
};

export function rfqLineDocumentAccessPresentation(
  documents: RfqSkuDocumentAccessDocument[],
  access?: RfqSkuDocumentAccessSummary,
): {
  hasAccess: boolean;
  helperText: string;
  buttonLabel: string;
} {
  const hasModuleAccess = access?.documentsModule === true;
  const hasSharedFiles = documents.some((document) => controlledDocumentIsPreviewable(document));
  const hasAccess = hasModuleAccess || hasSharedFiles;
  const documentCount = documents.length;

  if (!hasAccess) {
    return {
      hasAccess: false,
      helperText: "Need a drawing or spec for this part number?",
      buttonLabel: "Request document access",
    };
  }

  if (documentCount === 0) {
    return {
      hasAccess: true,
      helperText: "You have Document Control access. No controlled documents are on this part number yet.",
      buttonLabel: "Request a document",
    };
  }

  const fileWord = documentCount === 1 ? "document" : "documents";
  const accessNote = hasModuleAccess
    ? "You have Document Control access."
    : "Shared documents are available for this part number.";
  return {
    hasAccess: true,
    helperText: `${documentCount} controlled ${fileWord} on this part number. ${accessNote}`,
    buttonLabel: "View documents",
  };
}
